import {Button} from '@mui/material';
import {toNumber} from 'lodash';
import {FC, MouseEventHandler} from 'react';

interface Props {
  archived?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const BUTTON_LABELS = ['В архив', 'Из архива'] as const;

export const ArchiveButton: FC<Props> = ({archived = false, onClick, disabled = false}) => {
  return (
    <Button color="warning" variant="outlined" onClick={onClick} disabled={disabled}>
      {BUTTON_LABELS[toNumber(archived)]}
    </Button>
  );
};
